"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCcNumberValid = exports.isPhoneNumberValid = exports.isEmailValid = void 0;
const luhn_1 = __importDefault(require("luhn"));
const isEmailValid = (value) => !!(value && value.match(/.+@.+\..+/));
exports.isEmailValid = isEmailValid;
const isPhoneNumberValid = (value) => {
    // Source: https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s03.html
    const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/u;
    return value && phoneRegex.test(value.startsWith('+') ? value : `+1${value}`);
};
exports.isPhoneNumberValid = isPhoneNumberValid;
const isCcNumberValid = (value) => value && luhn_1.default.validate(value);
exports.isCcNumberValid = isCcNumberValid;
//# sourceMappingURL=validations.js.map